var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcnLocationGray = function SvgIcnLocationGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 0A5.596 5.596 0 0 0 .5 5.6C.5 9.8 6.1 16 6.1 16s5.6-6.2 5.6-10.4C11.7 2.504 9.196 0 6.1 0Zm0 7.6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z",
    fill: "#0F1624",
    fillOpacity: 0.5
  })));
};

export { SvgIcnLocationGray as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMSAwQzMuMDA0IDAgMC41IDIuNTA0IDAuNSA1LjZDMC41IDkuOCA2LjEgMTYgNi4xIDE2QzYuMSAxNiAxMS43IDkuOCAxMS43IDUuNkMxMS43IDIuNTA0IDkuMTk2IDAgNi4xIDBaTTYuMSA3LjZDNS41Njk1NyA3LjYgNS4wNjA4NiA3LjM4OTI5IDQuNjg1NzkgNy4wMTQyMUM0LjMxMDcxIDYuNjM5MTQgNC4xIDYuMTMwNDMgNC4xIDUuNkM0LjEgNS4wNjk1NyA0LjMxMDcxIDQuNTYwODYgNC42ODU3OSA0LjE4NTc5QzUuMDYwODYgMy44MTA3MSA1LjU2OTU3IDMuNiA2LjEgMy42QzYuNjMwNDMgMy42IDcuMTM5MTQgMy44MTA3MSA3LjUxNDIxIDQuMTg1NzlDNy44ODkyOSA0LjU2MDg2IDguMSA1LjA2OTU3IDguMSA1LjZDOC4xIDYuMTMwNDMgNy44ODkyOSA2LjYzOTE0IDcuNTE0MjEgNy4wMTQyMUM3LjEzOTE0IDcuMzg5MjkgNi42MzA0MyA3LjYgNi4xIDcuNloiIGZpbGw9IiMwRjE2MjQiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";